/* YAMAKITS FAVORITES v1
   Système de favoris client-side (localStorage).
   API globale: window.ykFav
   Évènement: document dispatches "ykfav:change" après chaque modification.
*/
(function () {
  if (window.ykFav) return; // déjà initialisé

  var STORAGE_KEY = 'yamakits_favorites_v1';
  var MAX_ITEMS = 200;
  var productCache = {}; // handle -> product json
  var inFlight = {};     // handle -> Promise

  // Yamakits hidden variants (alignés avec liquid_Ec6iWe + cart-drawer-yamakits)
  var FLOC_ID = 63298429747549;
  var SHORT_ID = 63298432139613;
  var VPLAYER_ID = 63663011594589;
  var FLOC_UNIT = 99;
  var SHORT_PRICE = 2199;
  var VPLAYER_PRICE = 499;
  var SIZES = ['S', 'M', 'L', 'XL', '2XL'];

  function defaultConfig() {
    return { sz: '', floc: false, tab: 'custom', name: '', num: '', sub: '', player: null, short: false, shortSz: '', vplayer: false };
  }

  // Lit l'état courant depuis la page produit (DOM-based, lit les IDs du block yamakits-product-options)
  function readPdpConfig() {
    if (!/\/products\//.test(window.location.pathname)) return null;
    var atc = document.querySelector('#ykAddBtn');
    if (!atc) return null;
    var cfg = defaultConfig();
    var szOn = document.querySelector('#ykSizes .yk-sz-btn.on');
    if (szOn) cfg.sz = szOn.dataset.sz || '';
    var flocSwitch = document.querySelector('#ykFlocSwitch');
    cfg.floc = !!(flocSwitch && flocSwitch.classList.contains('on'));
    var tabOn = document.querySelector('#ykTabs .yk-tab.on');
    if (tabOn) cfg.tab = tabOn.dataset.tab || 'custom';
    var nameEl = document.getElementById('ykName');
    if (nameEl) cfg.name = (nameEl.value || '').trim();
    var numEl = document.getElementById('ykNum');
    if (numEl) cfg.num = (numEl.value || '').trim();
    var subEl = document.getElementById('ykSub');
    if (subEl) cfg.sub = (subEl.value || '').trim();
    var playerOn = document.querySelector('#ykPlayersGrid .yk-player.on');
    if (playerOn) cfg.player = { n: playerOn.dataset.n || '', name: playerOn.dataset.name || '' };
    var shortSwitch = document.querySelector('#ykShortSwitch');
    cfg.short = !!(shortSwitch && shortSwitch.classList.contains('on'));
    var shortSzOn = document.querySelector('#ykShortSizes .yk-sz-btn.on');
    if (shortSzOn) cfg.shortSz = shortSzOn.dataset.sz || '';
    var vpSwitch = document.querySelector('#ykVPlayerSwitch');
    cfg.vplayer = !!(vpSwitch && vpSwitch.classList.contains('on'));
    return cfg;
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (e) {
        return e && typeof e.handle === 'string' && e.handle.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function writeStore(list) {
    try {
      if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function emit() {
    try {
      document.dispatchEvent(new CustomEvent('ykfav:change', { detail: { count: ykFav.count() } }));
    } catch (e) {}
  }

  function has(handle) {
    if (!handle) return false;
    var list = readStore();
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) return true;
    return false;
  }

  function add(handle, meta) {
    if (!handle) return false;
    var list = readStore();
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) return false;
    var entry = {
      handle: handle,
      addedAt: Date.now(),
      title: (meta && meta.title) || '',
      image: (meta && meta.image) || '',
      config: (meta && meta.config) || defaultConfig()
    };
    list.unshift(entry);
    writeStore(list);
    emit();
    return true;
  }

  function updateConfig(handle, patch) {
    if (!handle || !patch) return false;
    var list = readStore();
    var changed = false;
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) {
        list[i].config = Object.assign({}, defaultConfig(), list[i].config || {}, patch);
        changed = true;
        break;
      }
    }
    if (!changed) return false;
    writeStore(list);
    // pas d'emit pour ne pas re-render le drawer (l'utilisateur édite en cours)
    return true;
  }

  function getConfig(handle) {
    var list = readStore();
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) {
      return Object.assign({}, defaultConfig(), list[i].config || {});
    }
    return defaultConfig();
  }

  function remove(handle) {
    if (!handle) return false;
    var list = readStore();
    var next = list.filter(function (e) { return e.handle !== handle; });
    if (next.length === list.length) return false;
    writeStore(next);
    emit();
    return true;
  }

  function toggle(handle, meta) {
    return has(handle) ? (remove(handle), false) : (add(handle, meta), true);
  }

  function count() {
    return readStore().length;
  }

  function list() {
    return readStore().slice();
  }

  function clear() {
    writeStore([]);
    emit();
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (inFlight[handle]) return inFlight[handle];
    var locale = '';
    var path = window.location.pathname || '';
    var m = path.match(/^\/(en|ar|fr)(\/|$)/);
    if (m && m[1] !== 'fr') locale = '/' + m[1];
    var url = locale + '/products/' + encodeURIComponent(handle) + '.js';
    inFlight[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (p) {
        productCache[handle] = p;
        delete inFlight[handle];
        return p;
      })
      .catch(function (err) {
        delete inFlight[handle];
        throw err;
      });
    return inFlight[handle];
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format || '€{{amount}}'); } catch (e) {}
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function open() {
    var drawer = document.getElementById('ykfD');
    var overlay = document.getElementById('ykfO');
    if (!drawer || !overlay) return;
    render();
    drawer.classList.add('on');
    overlay.classList.add('on');
    document.body.classList.add('ykf-lock');
  }

  function close() {
    var drawer = document.getElementById('ykfD');
    var overlay = document.getElementById('ykfO');
    if (drawer) drawer.classList.remove('on');
    if (overlay) overlay.classList.remove('on');
    document.body.classList.remove('ykf-lock');
  }

  function isOpen() {
    var d = document.getElementById('ykfD');
    return !!(d && d.classList.contains('on'));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function productUrl(handle) {
    var locale = '';
    var path = window.location.pathname || '';
    var m = path.match(/^\/(en|ar|fr)(\/|$)/);
    if (m && m[1] !== 'fr') locale = '/' + m[1];
    return locale + '/products/' + encodeURIComponent(handle);
  }

  function hasSizeOptions(product) {
    if (!product || !product.variants || product.variants.length <= 1) return false;
    // Test si une variante a un option1 dans la liste des tailles
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var o = (v.option1 || v.title || '').toString().trim().toUpperCase();
      if (SIZES.indexOf(o) !== -1) return true;
    }
    return false;
  }

  function calcItemTotal(product, cfg) {
    var base = (product && typeof product.price === 'number') ? product.price : 0;
    var total = base;
    var flocQty = countFlocFields(cfg);
    total += flocQty * FLOC_UNIT;
    if (cfg.short) total += SHORT_PRICE;
    if (cfg.vplayer) total += VPLAYER_PRICE;
    return total;
  }

  function countFlocFields(cfg) {
    if (!cfg.floc) return 0;
    if (cfg.tab === 'players' && cfg.player) return 2;
    var n = 0;
    if (cfg.name) n++;
    if (cfg.num) n++;
    if (cfg.sub) n++;
    return n;
  }

  function flocBreakdownHtml(cfg) {
    var parts = [];
    if (cfg.sz) parts.push(escapeHtml(cfg.sz));
    if (cfg.floc) {
      if (cfg.tab === 'players' && cfg.player) parts.push(escapeHtml(cfg.player.name + ' #' + cfg.player.n));
      else {
        var bits = [];
        if (cfg.name) bits.push(escapeHtml(cfg.name.toUpperCase()));
        if (cfg.num) bits.push('#' + escapeHtml(cfg.num));
        if (cfg.sub) bits.push(escapeHtml(cfg.sub.toUpperCase()));
        if (bits.length) parts.push(bits.join(' '));
      }
    }
    if (cfg.short && cfg.shortSz) parts.push('Short ' + escapeHtml(cfg.shortSz));
    if (cfg.vplayer) parts.push('Player');
    if (!parts.length) return '';
    return '<div class="ykf-item-summary">' + parts.join(' · ') + '</div>';
  }

  function sizesHtml(cfg, handle, includeSize) {
    if (!includeSize) return '';
    var btns = SIZES.map(function (s) {
      var on = cfg.sz === s ? ' on' : '';
      return '<button type="button" class="ykf-sz-btn' + on + '" data-ykf-size="' + s + '" data-ykf-h="' + escapeHtml(handle) + '">' + s + '</button>';
    }).join('');
    return ''
      + '<div class="ykf-row ykf-row--sizes">'
      +   '<div class="ykf-row-label">Taille</div>'
      +   '<div class="ykf-sizes">' + btns + '</div>'
      + '</div>';
  }

  function flocEditorHtml(cfg, handle) {
    var openCls = cfg.floc ? ' on' : '';
    var nameDisp = '';
    var numDisp = '';
    var subDisp = '';
    if (cfg.tab === 'players' && cfg.player) {
      nameDisp = escapeHtml(cfg.player.name);
      numDisp = escapeHtml(cfg.player.n);
    } else {
      nameDisp = cfg.name ? escapeHtml(cfg.name.toUpperCase()) : '';
      numDisp = cfg.num ? escapeHtml(cfg.num) : '';
      subDisp = cfg.sub ? escapeHtml(cfg.sub.toUpperCase()) : '';
    }
    var playerLocked = (cfg.tab === 'players' && cfg.player) ? '<div class="ykf-player-locked">Joueur officiel — modifiable sur la page produit</div>' : '';
    return ''
      + '<div class="ykf-row ykf-row--floc">'
      +   '<div class="ykf-floc-toggle" data-ykf-floc-toggle="' + escapeHtml(handle) + '">'
      +     '<div class="ykf-floc-toggle-left">'
      +       '<span class="ykf-floc-icon">✏️</span>'
      +       '<span class="ykf-floc-title">Flocage personnalisé</span>'
      +       '<span class="ykf-floc-price">+0,99€ / élément</span>'
      +     '</div>'
      +     '<button type="button" class="ykf-switch' + openCls + '" data-ykf-floc-switch="' + escapeHtml(handle) + '" aria-pressed="' + (cfg.floc ? 'true' : 'false') + '"><span class="ykf-switch-knob"></span></button>'
      +   '</div>'
      +   '<div class="ykf-floc-body' + openCls + '" data-ykf-floc-body="' + escapeHtml(handle) + '">'
      +     '<div class="ykf-floc-preview">'
      +       '<div class="ykf-floc-prev-name' + (nameDisp ? ' has' : '') + '">' + (nameDisp || 'NOM') + '</div>'
      +       '<div class="ykf-floc-prev-num' + (numDisp ? ' has' : '') + '">' + (numDisp || '00') + '</div>'
      +       '<div class="ykf-floc-prev-sub' + (subDisp ? ' has' : '') + '">' + subDisp + '</div>'
      +     '</div>'
      +     playerLocked
      +     '<div class="ykf-floc-inputs">'
      +       '<input type="text" class="ykf-floc-input" data-ykf-floc-field="name" data-ykf-h="' + escapeHtml(handle) + '" placeholder="Nom" maxlength="12" value="' + escapeHtml(cfg.name) + '">'
      +       '<input type="text" class="ykf-floc-input ykf-floc-input--sm" data-ykf-floc-field="num" data-ykf-h="' + escapeHtml(handle) + '" placeholder="N°" maxlength="3" inputmode="numeric" value="' + escapeHtml(cfg.num) + '">'
      +     '</div>'
      +     '<input type="text" class="ykf-floc-input" data-ykf-floc-field="sub" data-ykf-h="' + escapeHtml(handle) + '" placeholder="Sous le numéro" maxlength="12" value="' + escapeHtml(cfg.sub) + '">'
      +   '</div>'
      + '</div>';
  }

  function shortEditorHtml(cfg, handle, includeSize) {
    var onCls = cfg.short ? ' on' : '';
    var sizesHtml = '';
    if (cfg.short && includeSize) {
      sizesHtml = '<div class="ykf-short-sizes">' + SIZES.map(function (s) {
        var sc = cfg.shortSz === s ? ' on' : '';
        return '<button type="button" class="ykf-sz-btn' + sc + '" data-ykf-short-size="' + s + '" data-ykf-h="' + escapeHtml(handle) + '">' + s + '</button>';
      }).join('') + '</div>';
    }
    return ''
      + '<div class="ykf-row ykf-row--addon">'
      +   '<div class="ykf-addon-toggle">'
      +     '<div class="ykf-addon-left"><span class="ykf-addon-icon">🩳</span><span class="ykf-addon-title">Ajouter le short</span><span class="ykf-addon-price">+21,99€</span></div>'
      +     '<button type="button" class="ykf-switch' + onCls + '" data-ykf-short-switch="' + escapeHtml(handle) + '" aria-pressed="' + (cfg.short ? 'true' : 'false') + '"><span class="ykf-switch-knob"></span></button>'
      +   '</div>'
      +   sizesHtml
      + '</div>';
  }

  function vplayerEditorHtml(cfg, handle) {
    var onCls = cfg.vplayer ? ' on' : '';
    return ''
      + '<div class="ykf-row ykf-row--addon">'
      +   '<div class="ykf-addon-toggle">'
      +     '<div class="ykf-addon-left"><span class="ykf-addon-icon">⭐</span><span class="ykf-addon-title">Version Player</span><span class="ykf-addon-price">+4,99€</span></div>'
      +     '<button type="button" class="ykf-switch' + onCls + '" data-ykf-vplayer-switch="' + escapeHtml(handle) + '" aria-pressed="' + (cfg.vplayer ? 'true' : 'false') + '"><span class="ykf-switch-knob"></span></button>'
      +   '</div>'
      + '</div>';
  }

  function itemHtml(entry, product) {
    var title = (product && product.title) || entry.title || entry.handle;
    var image = '';
    if (product && product.featured_image) image = product.featured_image;
    else if (product && product.images && product.images[0]) image = product.images[0];
    else if (entry.image) image = entry.image;
    if (image && image.indexOf('//') === 0) image = window.location.protocol + image;
    var cfg = Object.assign({}, defaultConfig(), entry.config || {});
    var withSize = hasSizeOptions(product);
    var basePrice = (product && typeof product.price === 'number') ? product.price : 0;
    var total = calcItemTotal(product, cfg);
    var priceHtml = '';
    if (basePrice > 0) {
      if (total > basePrice) {
        priceHtml = '<span class="ykf-price">' + money(total) + '</span> <span class="ykf-price-base">(base ' + money(basePrice) + ')</span>';
      } else if (product && typeof product.compare_at_price === 'number' && product.compare_at_price > product.price) {
        priceHtml = '<span class="ykf-price">' + money(basePrice) + '</span> <span class="ykf-price-old">' + money(product.compare_at_price) + '</span>';
      } else {
        priceHtml = '<span class="ykf-price">' + money(basePrice) + '</span>';
      }
    }
    var available = product ? !!product.available : true;
    var addLabel = withSize && !cfg.sz ? 'Choisir une taille' : 'Ajouter au panier';
    var addDisabled = withSize && !cfg.sz;
    var addBtn = available
      ? '<button type="button" class="ykf-add' + (addDisabled ? ' is-disabled' : '') + '" data-ykf-add="' + escapeHtml(entry.handle) + '"' + (addDisabled ? ' disabled' : '') + '>' + addLabel + (total > 0 ? ' · ' + money(total) : '') + '</button>'
      : '<span class="ykf-soldout">Épuisé</span>';
    return ''
      + '<div class="ykf-item" data-ykf-handle="' + escapeHtml(entry.handle) + '">'
      +   '<div class="ykf-item-head">'
      +     '<a class="ykf-item-img-link" href="' + escapeHtml(productUrl(entry.handle)) + '">'
      +       (image ? '<img class="ykf-item-img" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '<div class="ykf-item-img ykf-item-img--ph"></div>')
      +     '</a>'
      +     '<div class="ykf-item-info">'
      +       '<a class="ykf-item-name" href="' + escapeHtml(productUrl(entry.handle)) + '">' + escapeHtml(title) + '</a>'
      +       (priceHtml ? '<div class="ykf-item-price-row">' + priceHtml + '</div>' : '')
      +       flocBreakdownHtml(cfg)
      +     '</div>'
      +     '<button type="button" class="ykf-rm" data-ykf-remove="' + escapeHtml(entry.handle) + '" aria-label="Retirer des favoris">'
      +       '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>'
      +     '</button>'
      +   '</div>'
      +   sizesHtml(cfg, entry.handle, withSize)
      +   flocEditorHtml(cfg, entry.handle)
      +   shortEditorHtml(cfg, entry.handle, withSize)
      +   vplayerEditorHtml(cfg, entry.handle)
      +   '<div class="ykf-item-actions">' + addBtn + '</div>'
      + '</div>';
  }

  function render() {
    var body = document.getElementById('ykfBody');
    var badge = document.getElementById('ykfC');
    if (!body) return;
    var entries = readStore();
    if (badge) badge.textContent = entries.length;

    if (entries.length === 0) {
      body.innerHTML = ''
        + '<div class="ykf-empty">'
        +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        +   '<h3>Aucun favori</h3>'
        +   '<p>Ajoutez vos produits préférés pour les retrouver ici.</p>'
        +   '<a href="/collections/maillot-de-football" class="ykf-cta">Découvrir les produits</a>'
        + '</div>';
      return;
    }

    // skeleton render first (instant), then fill with product data
    body.innerHTML = entries.map(function (e) {
      return itemHtml(e, productCache[e.handle] || null);
    }).join('');

    entries.forEach(function (entry) {
      if (productCache[entry.handle]) return;
      fetchProduct(entry.handle).then(function (product) {
        if (!isOpen()) return;
        var node = body.querySelector('[data-ykf-handle="' + cssEscape(entry.handle) + '"]');
        if (!node) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = itemHtml(entry, product);
        node.replaceWith(wrapper.firstChild);
      }).catch(function () {
        // produit introuvable -> on le retire silencieusement
        remove(entry.handle);
        if (isOpen()) render();
      });
    });
  }

  function cssEscape(s) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, function (c) { return '\\' + c; });
  }

  function refresh() { render(); }

  // ---- ATC depuis le drawer favoris : envoie le multi-line-item Yamakits ----
  function addToCartFromFav(handle) {
    fetchProduct(handle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return;
      var cfg = getConfig(handle);
      var withSize = hasSizeOptions(product);
      var variant = null;
      if (withSize && cfg.sz) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var o = (v.option1 || v.title || '').toString().trim().toUpperCase();
          if (o === cfg.sz.toUpperCase()) { variant = v; break; }
        }
      }
      if (!variant) {
        // fallback : 1re variante dispo
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j].available) { variant = product.variants[j]; break; }
        }
        if (!variant) variant = product.variants[0];
      }
      if (!variant) return;

      var props = {};
      if (cfg.sz) props['Taille'] = cfg.sz;
      var flocQty = 0;
      if (cfg.floc) {
        if (cfg.tab === 'players' && cfg.player) {
          props['Joueur'] = cfg.player.name + ' #' + cfg.player.n;
          flocQty = 2;
        } else {
          if (cfg.name) { props['Nom'] = cfg.name.toUpperCase(); flocQty++; }
          if (cfg.num) { props['Numéro'] = cfg.num; flocQty++; }
          if (cfg.sub) { props['Sous-numéro'] = cfg.sub.toUpperCase(); flocQty++; }
        }
      }
      if (cfg.short && cfg.shortSz) props['Short'] = 'Taille ' + cfg.shortSz;
      if (cfg.vplayer) props['Version Player'] = 'Activée';

      var items = [{ id: parseInt(variant.id, 10), quantity: 1, properties: props }];
      if (flocQty > 0) items.push({ id: FLOC_ID, quantity: flocQty, properties: { '_hidden': '1' } });
      if (cfg.short && cfg.shortSz) items.push({ id: SHORT_ID, quantity: 1, properties: { '_hidden': '1' } });
      if (cfg.vplayer) items.push({ id: VPLAYER_ID, quantity: 1, properties: { '_hidden': '1' } });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add failed');
          return r.json();
        })
        .then(function () {
          close();
          if (window.ykCart && typeof window.ykCart.refresh === 'function') window.ykCart.refresh();
          if (window.ykCart && typeof window.ykCart.open === 'function') window.ykCart.open();
        })
        .catch(function (e) { console.error('[ykFav] add to cart error', e); });
    }).catch(function () {});
  }

  // ---- Event handlers pour les éditeurs in-drawer ----
  function reRenderItem(handle) {
    var body = document.getElementById('ykfBody');
    if (!body) return;
    var node = body.querySelector('[data-ykf-handle="' + cssEscape(handle) + '"]');
    if (!node) return;
    var list = readStore();
    var entry = null;
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) { entry = list[i]; break; }
    if (!entry) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = itemHtml(entry, productCache[handle] || null);
    node.replaceWith(wrap.firstChild);
  }

  function handleDrawerEvents(e) {
    var sizeBtn = e.target.closest('[data-ykf-size]');
    if (sizeBtn) {
      e.preventDefault();
      updateConfig(sizeBtn.getAttribute('data-ykf-h'), { sz: sizeBtn.getAttribute('data-ykf-size') });
      reRenderItem(sizeBtn.getAttribute('data-ykf-h'));
      return;
    }
    var flocSwitch = e.target.closest('[data-ykf-floc-switch]');
    if (flocSwitch) {
      e.preventDefault();
      var h = flocSwitch.getAttribute('data-ykf-floc-switch');
      var cur = getConfig(h);
      updateConfig(h, { floc: !cur.floc });
      reRenderItem(h);
      return;
    }
    var flocToggleRow = e.target.closest('[data-ykf-floc-toggle]');
    if (flocToggleRow && !e.target.closest('[data-ykf-floc-switch]')) {
      // clic sur la ligne titre (en dehors du switch) -> toggle aussi le switch
      e.preventDefault();
      var h2 = flocToggleRow.getAttribute('data-ykf-floc-toggle');
      var cur2 = getConfig(h2);
      updateConfig(h2, { floc: !cur2.floc });
      reRenderItem(h2);
      return;
    }
    var shortSwitch = e.target.closest('[data-ykf-short-switch]');
    if (shortSwitch) {
      e.preventDefault();
      var sh = shortSwitch.getAttribute('data-ykf-short-switch');
      var sc = getConfig(sh);
      var newShort = !sc.short;
      var newSz = newShort && !sc.shortSz ? (sc.sz || 'M') : sc.shortSz;
      updateConfig(sh, { short: newShort, shortSz: newShort ? newSz : '' });
      reRenderItem(sh);
      return;
    }
    var shortSize = e.target.closest('[data-ykf-short-size]');
    if (shortSize) {
      e.preventDefault();
      updateConfig(shortSize.getAttribute('data-ykf-h'), { shortSz: shortSize.getAttribute('data-ykf-short-size') });
      reRenderItem(shortSize.getAttribute('data-ykf-h'));
      return;
    }
    var vpSwitch = e.target.closest('[data-ykf-vplayer-switch]');
    if (vpSwitch) {
      e.preventDefault();
      var vh = vpSwitch.getAttribute('data-ykf-vplayer-switch');
      var vc = getConfig(vh);
      updateConfig(vh, { vplayer: !vc.vplayer });
      reRenderItem(vh);
      return;
    }
  }

  function handleDrawerInput(e) {
    var input = e.target.closest('[data-ykf-floc-field]');
    if (!input) return;
    var field = input.getAttribute('data-ykf-floc-field');
    var h = input.getAttribute('data-ykf-h');
    var patch = {};
    patch[field] = input.value;
    updateConfig(h, patch);
    // Update preview en live sans tout re-rendre (sinon focus perdu)
    var item = input.closest('.ykf-item');
    if (!item) return;
    var nameEl = item.querySelector('.ykf-floc-prev-name');
    var numEl = item.querySelector('.ykf-floc-prev-num');
    var subEl = item.querySelector('.ykf-floc-prev-sub');
    var cfg = getConfig(h);
    if (cfg.tab === 'players' && cfg.player) return;
    if (nameEl) { nameEl.textContent = cfg.name ? cfg.name.toUpperCase() : 'NOM'; nameEl.classList.toggle('has', !!cfg.name); }
    if (numEl) { numEl.textContent = cfg.num || '00'; numEl.classList.toggle('has', !!cfg.num); }
    if (subEl) { subEl.textContent = cfg.sub ? cfg.sub.toUpperCase() : ''; subEl.classList.toggle('has', !!cfg.sub); }
    // Update total/breakdown
    refreshItemTotals(item, h);
  }

  function refreshItemTotals(item, h) {
    var cfg = getConfig(h);
    var prod = productCache[h];
    var total = calcItemTotal(prod, cfg);
    var addBtn = item.querySelector('.ykf-add');
    if (addBtn) {
      var withSize = hasSizeOptions(prod);
      var label = withSize && !cfg.sz ? 'Choisir une taille' : 'Ajouter au panier';
      addBtn.textContent = label + (total > 0 ? ' · ' + money(total) : '');
      addBtn.classList.toggle('is-disabled', withSize && !cfg.sz);
      addBtn.disabled = withSize && !cfg.sz;
    }
    // summary line
    var summary = item.querySelector('.ykf-item-summary');
    var wrap = document.createElement('div');
    wrap.innerHTML = flocBreakdownHtml(cfg);
    var newSummary = wrap.firstChild;
    var info = item.querySelector('.ykf-item-info');
    if (summary) summary.remove();
    if (newSummary && info) info.appendChild(newSummary);
  }

  // ---- API exportée ----
  window.ykFav = {
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    count: count,
    list: list,
    clear: clear,
    open: open,
    close: close,
    refresh: refresh
  };

  // ---- Custom elements ----
  // <ykfav-toggle handle="..."> renders nothing on its own; child button is wired.
  // <ykfav-count> shows the current count (badge).

  function syncToggleEl(el) {
    var handle = el.getAttribute('handle') || el.dataset.handle;
    if (!handle) return;
    var active = has(handle);
    el.classList.toggle('is-active', active);
    var btn = el.querySelector('button, [role="button"]');
    if (btn) {
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var labelOn = el.getAttribute('label-on') || 'Retirer des favoris';
      var labelOff = el.getAttribute('label-off') || 'Ajouter aux favoris';
      var labelEl = btn.querySelector('[data-ykfav-label]');
      if (labelEl) labelEl.textContent = active ? labelOn : labelOff;
    }
  }

  function syncAllToggles() {
    document.querySelectorAll('ykfav-toggle, [data-ykfav-toggle]').forEach(syncToggleEl);
  }

  function syncCount() {
    var n = count();
    document.querySelectorAll('ykfav-count, [data-ykfav-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // Event delegation
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-ykfav-open]');
    if (openTrigger) {
      e.preventDefault();
      open();
      return;
    }

    var closeTrigger = e.target.closest('[data-ykfav-close]');
    if (closeTrigger) {
      e.preventDefault();
      close();
      return;
    }

    var toggleTrigger = e.target.closest('[data-ykfav-handle]');
    if (toggleTrigger && (toggleTrigger.tagName === 'BUTTON' || toggleTrigger.getAttribute('role') === 'button')) {
      e.preventDefault();
      var handle = toggleTrigger.getAttribute('data-ykfav-handle');
      var meta = {
        title: toggleTrigger.getAttribute('data-ykfav-title') || '',
        image: toggleTrigger.getAttribute('data-ykfav-image') || '',
        config: readPdpConfig() || defaultConfig()
      };
      toggle(handle, meta);
      return;
    }

    var rm = e.target.closest('[data-ykf-remove]');
    if (rm) {
      e.preventDefault();
      remove(rm.getAttribute('data-ykf-remove'));
      render();
      return;
    }

    var addBtn = e.target.closest('[data-ykf-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.classList.contains('is-disabled') || addBtn.disabled) return;
      addToCartFromFav(addBtn.getAttribute('data-ykf-add'));
      return;
    }

    // Handlers in-drawer flocking editor
    handleDrawerEvents(e);
  }, false);

  document.addEventListener('input', handleDrawerInput, false);
  document.addEventListener('change', handleDrawerInput, false);

  // Cross-tab sync
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      syncAllToggles();
      syncCount();
      if (isOpen()) render();
    }
  });

  document.addEventListener('ykfav:change', function () {
    syncAllToggles();
    syncCount();
  });

  // Initial sync (and re-sync on dynamic re-renders, e.g. Impact's product-rerender)
  function initialSync() {
    syncAllToggles();
    syncCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }

  // Re-sync when product-rerender swaps content
  var mo = new MutationObserver(function (mutations) {
    var needs = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('ykfav-toggle, [data-ykfav-toggle], ykfav-count, [data-ykfav-count]') ||
            n.querySelector && n.querySelector('ykfav-toggle, [data-ykfav-toggle], ykfav-count, [data-ykfav-count]'))) {
          needs = true; break;
        }
      }
      if (needs) break;
    }
    if (needs) initialSync();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // ESC close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // ---- Injection automatique du bouton "Ajouter aux favoris" sous l'ATC custom Yamakits sur la page produit ----
  function getProductMetaFromPage() {
    var path = window.location.pathname || '';
    var m = path.match(/\/products\/([^\/?#]+)/);
    if (!m) return null;
    var handle = decodeURIComponent(m[1]);
    var titleEl = document.querySelector('.product-info__title, [itemprop="name"], h1.product-info__title') ||
                  document.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    if (!title) {
      var og = document.querySelector('meta[property="og:title"]');
      if (og) title = og.getAttribute('content') || '';
    }
    var image = '';
    var ogImg = document.querySelector('meta[property="og:image"]');
    if (ogImg) image = ogImg.getAttribute('content') || '';
    if (!image) {
      var img = document.querySelector('.product-gallery__media img, .product-info img, img');
      if (img) image = img.src || '';
    }
    return { handle: handle, title: title, image: image };
  }

  function buildFavButton(meta) {
    var wrap = document.createElement('ykfav-toggle');
    wrap.className = 'ykf-toggle ykf-toggle--full';
    wrap.setAttribute('handle', meta.handle);
    wrap.setAttribute('label-on', 'Retirer des favoris');
    wrap.setAttribute('label-off', 'Ajouter aux favoris');
    wrap.setAttribute('data-ykfav-injected', '1');
    wrap.innerHTML = ''
      + '<button type="button" class="ykf-toggle__btn" role="button" aria-pressed="false" aria-label="Ajouter aux favoris"'
      +   ' data-ykfav-handle="' + escapeHtml(meta.handle) + '"'
      +   ' data-ykfav-title="' + escapeHtml(meta.title) + '"'
      +   ' data-ykfav-image="' + escapeHtml(meta.image) + '">'
      +   '<span data-ykfav-label>Ajouter aux favoris</span>'
      +   '<svg class="ykf-heart" viewBox="0 0 24 24" aria-hidden="true">'
      +     '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
      +   '</svg>'
      + '</button>';
    return wrap;
  }

  function injectProductFavButton() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var atc = document.querySelector('#ykAddBtn, .yk-add-btn');
    if (!atc) return;
    // Déjà injecté dans ce parent ? On marque le spacer d'un data attribute unique.
    if (atc.parentNode.querySelector(':scope > [data-ykfav-spacer="1"]')) return;
    var meta = getProductMetaFromPage();
    if (!meta) return;
    var btn = buildFavButton(meta);
    var spacer = document.createElement('div');
    spacer.setAttribute('data-ykfav-spacer', '1');
    spacer.style.marginTop = '10px';
    spacer.appendChild(btn);
    atc.parentNode.insertBefore(spacer, atc.nextSibling);
    syncToggleEl(btn);
    console.log('[ykFav] favorites button injected after ATC');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectProductFavButton);
  } else {
    injectProductFavButton();
  }
  // Re-tente après les scripts d'Impact / Yamakits qui mutent le DOM
  setTimeout(injectProductFavButton, 600);
  setTimeout(injectProductFavButton, 1500);
  setTimeout(injectProductFavButton, 3000);

  // Observe les re-renders (variant change, etc.) — debounced + scope limité
  var injectScheduled = false;
  function scheduleInject() {
    if (injectScheduled) return;
    injectScheduled = true;
    requestAnimationFrame(function () {
      injectScheduled = false;
      injectProductFavButton();
    });
  }
  var injectObserver = new MutationObserver(scheduleInject);
  injectObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
